const state = {
    left: [
        {
            name: 'Общие вопросы',
            questions: [
                {
                    heading: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться',
                    desc: 'Многие программы электронной верстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию,' +
                    'так что поиск по ключевым словам lorem ipsum сразу показывает, как много веб-страниц все еще ' +
                    'дожидаются своего настоящего рождения. За прошедшие годы текст Lorem Ipsum получил много версий.' +
                    'Некоторые версии получились по ошибке, некоторые - намеренно (например, варианты)',
                    collapsed: true,
                    hidden: false
                },
                {
                    heading: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться',
                    desc: 'Многие программы электронной верстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию,' +
                    'так что поиск по ключевым словам lorem ipsum сразу показывает, как много веб-страниц все еще ' +
                    'дожидаются своего настоящего рождения. За прошедшие годы текст Lorem Ipsum получил много версий.' +
                    'Некоторые версии получились по ошибке, некоторые - намеренно (например, варианты)',
                    collapsed: false,
                    hidden: false
                },
                {
                    heading: 'выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться',
                    desc: 'Многие программы электронной верстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию,' +
                    'так что поиск по ключевым словам lorem ipsum сразу показывает, как много веб-страниц все еще ' +
                    'дожидаются своего настоящего рождения. За прошедшие годы текст Lorem Ipsum получил много версий.' +
                    'Некоторые версии получились по ошибке, некоторые - намеренно (например, варианты)',
                    collapsed: true,
                    hidden: false
                },
            ]
        },
        {
            name: 'О LoRaWAN',
            questions: [
                {
                    heading: 'LoRaWAN',
                    desc: 'LoRaWAN (Long Range wide-area networks)  - технология, позволяющая обьеденить в одной сети множество, ' +
                    'устройств с низким энергопотреблением и обеспечить значительную дальность связи, ' +
                    'для передачи небольших по объему данных.',
                    collapsed: true,
                    hidden: false
                },
                {
                    heading: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться',
                    desc: 'Многие программы электронной верстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию,' +
                    'так что поиск по ключевым словам lorem ipsum сразу показывает, как много веб-страниц все еще ' +
                    'дожидаются своего настоящего рождения. За прошедшие годы текст Lorem Ipsum получил много версий.' +
                    'Некоторые версии получились по ошибке, некоторые - намеренно (например, варианты)',
                    collapsed: true,
                    hidden: false
                },
                {
                    heading: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться',
                    desc: 'Многие программы электронной верстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию,' +
                    'так что поиск по ключевым словам lorem ipsum сразу показывает, как много веб-страниц все еще ' +
                    'дожидаются своего настоящего рождения. За прошедшие годы текст Lorem Ipsum получил много версий.' +
                    'Некоторые версии получились по ошибке, некоторые - намеренно (например, варианты)',
                    collapsed: true,
                    hidden: false
                },
            ]
        }
    ],
    right: [
        {
            name: 'Вопросы по устройствам Умного дома',
            questions: [
                {
                    heading: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться',
                    desc: 'Многие программы электронной верстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию,' +
                    'так что поиск по ключевым словам lorem ipsum сразу показывает, как много веб-страниц все еще ' +
                    'дожидаются своего настоящего рождения. За прошедшие годы текст Lorem Ipsum получил много версий.' +
                    'Некоторые версии получились по ошибке, некоторые - намеренно (например, варианты)',
                    collapsed: true,
                    hidden: false
                },
                {
                    heading: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться',
                    desc: 'Многие программы электронной верстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию,' +
                    'так что поиск по ключевым словам lorem ipsum сразу показывает, как много веб-страниц все еще ' +
                    'дожидаются своего настоящего рождения. За прошедшие годы текст Lorem Ipsum получил много версий.' +
                    'Некоторые версии получились по ошибке, некоторые - намеренно (например, варианты)',
                    collapsed: true,
                    hidden: false
                },
                {
                    heading: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться',
                    desc: 'Многие программы электронной верстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию,' +
                    'так что поиск по ключевым словам lorem ipsum сразу показывает, как много веб-страниц все еще ' +
                    'дожидаются своего настоящего рождения. За прошедшие годы текст Lorem Ipsum получил много версий.' +
                    'Некоторые версии получились по ошибке, некоторые - намеренно (например, варианты)',
                    collapsed: true,
                    hidden: false
                },
            ]
        },
        {
            name: 'Технические вопросы',
            questions: [
                {
                    heading: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться',
                    desc: 'Многие программы электронной верстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию,' +
                    'так что поиск по ключевым словам lorem ipsum сразу показывает, как много веб-страниц все еще ' +
                    'дожидаются своего настоящего рождения. За прошедшие годы текст Lorem Ipsum получил много версий.' +
                    'Некоторые версии получились по ошибке, некоторые - намеренно (например, варианты)',
                    collapsed: true,
                    hidden: false
                },
                {
                    heading: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться',
                    desc: 'Многие программы электронной верстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию,' +
                    'так что поиск по ключевым словам lorem ipsum сразу показывает, как много веб-страниц все еще ' +
                    'дожидаются своего настоящего рождения. За прошедшие годы текст Lorem Ipsum получил много версий.' +
                    'Некоторые версии получились по ошибке, некоторые - намеренно (например, варианты)',
                    collapsed: false,
                    hidden: false
                },
                {
                    heading: 'Давно выяснено, что при оценке дизайна и композиции читаемый текст мешает сосредоточиться',
                    desc: 'Многие программы электронной верстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию,' +
                    'так что поиск по ключевым словам lorem ipsum сразу показывает, как много веб-страниц все еще ' +
                    'дожидаются своего настоящего рождения. За прошедшие годы текст Lorem Ipsum получил много версий.' +
                    'Некоторые версии получились по ошибке, некоторые - намеренно (например, варианты)',
                    collapsed: true,
                    hidden: false
                },
            ]
        }
    ]
}

export default {
    state
}


// WEBPACK FOOTER //
// ./src/store/modules/faq/faq.js